<template>
  <div class="project-members">
    <!-- 页面标题已由 ProjectLayout 处理，此处不需要额外标题 -->
    
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="showAddDialog">添加成员</el-button>
    </div>
    
    <el-table :data="members" stripe>
      <el-table-column label="用户名">
        <template slot-scope="{ row }">{{ row.Username || row.username || '-' }}</template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="Role" label="角色" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="getRoleType(row.Role || row.role)" size="small">{{ getRoleLabel(row.Role || row.role) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="加入时间" width="180">
        <template slot-scope="{ row }">{{ formatTime(row.CreatedTime || row.createdTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="{ row }">
          <el-button size="mini" type="text" @click="changeRole(row)">修改角色</el-button>
          <el-button size="mini" type="text" class="danger" @click="removeMember(row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 添加成员对话框 -->
    <el-dialog title="添加成员" :visible.sync="dialogVisible" width="400px">
      <el-form :model="formData" label-width="80px">
        <el-form-item label="选择用户">
          <el-select v-model="formData.userId" filterable placeholder="搜索用户" style="width: 100%">
            <el-option v-for="u in userList" :key="u.id" :label="u.name" :value="u.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="角色">
          <el-radio-group v-model="formData.role">
            <el-radio label="admin">管理员</el-radio>
            <el-radio label="member">成员</el-radio>
            <el-radio label="viewer">查看者</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAdd">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProjectMembers, addProjectMember, updateProjectMember, deleteProjectMember } from '@/app/index/api/project/manager'

export default {
  name: 'ProjectMembers',
  data() {
    return {
      projectId: null,
      projectName: '项目',
      members: [],
      userList: [], // TODO: Load from user search API
      dialogVisible: false,
      formData: {
        userId: null,
        role: 'member'
      }
    }
  },
  mounted() {
    this.projectId = this.$route.params.projectId
    this.loadMembers()
  },
  methods: {
    goBack() {
      this.$router.push('/wodexiangmu/list')
    },
    getRoleType(role) {
      const map = { admin: 'danger', member: '', viewer: 'info' }
      return map[role] || ''
    },
    getRoleLabel(role) {
      const map = { admin: '管理员', member: '成员', viewer: '查看者' }
      return map[role] || role
    },
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      return date.toLocaleString('zh-CN', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      })
    },
    async loadMembers() {
      try {
        const res = await getProjectMembers({ ProjectId: parseInt(this.projectId) })
        // 响应结构: res.data = { success, data: [...] }
        this.members = res?.data?.data || res?.data || []
      } catch (e) {
        console.error(e)
      }
    },
    showAddDialog() {
      this.formData = { userId: null, role: 'member' }
      this.dialogVisible = true
      // TODO: 加载可选用户列表 API
      // For testing, mock some users if needed or wait for user search implementation
      // this.loadUserList()
    },
    async handleAdd() {
      if (!this.formData.userId) {
          this.$message.warning('请选择用户')
          return
      }
      try {
          await addProjectMember({
              projectId: this.projectId,
              userId: this.formData.userId,
              role: this.formData.role
          })
          this.$message.success('成员添加成功')
          this.dialogVisible = false
          this.loadMembers()
      } catch (e) {
          console.error(e)
      }
    },
    changeRole(member) {
      this.$prompt('请选择新角色 (admin/member/viewer)', '修改角色', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: member.role
      }).then(async ({ value }) => {
        try {
            await updateProjectMember({
                id: member.id,
                role: value
            })
            this.$message.success('角色修改成功')
            this.loadMembers()
        } catch (e) {
            console.error(e)
        }
      })
    },
    removeMember(member) {
      this.$confirm('确定要移除该成员吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
            await deleteProjectMember(member.id)
            this.$message.success('成员已移除')
            this.loadMembers()
        } catch (e) {
            console.error(e)
        }
      })
    }
  }
}
</script>

<style scoped>
.project-members {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.toolbar {
  margin-bottom: 20px;
}

.danger {
  color: #f56c6c;
}
</style>
